export default  {
    RETROSPECTIVE: 'R',
    PROSPECTIVE: 'P'
}